export enum OptimizedScheduleDialogStep {
  TEASER,
  BASIC_SETUP,
  EMPLOYEE_AVAILABILITY,
}
